import 'virtual:svg-icons-register'

import { addCollection } from '@iconify/vue/offline'
import iconCollections, { iconNames } from 'virtual:iconify-offline-collections'
import { loadFullCollection } from 'virtual:iconify-offline-full-collections'

iconCollections.forEach((collection) => addCollection(collection))

const bundledIconNames = new Set(iconNames)
const fullCollectionPromises = new Map<string, Promise<boolean>>()

export const ensureOfflineIcon = (iconName: string): Promise<boolean> => {
  if (bundledIconNames.has(iconName)) {
    return Promise.resolve(false)
  }
  const separatorIndex = iconName.indexOf(':')
  if (separatorIndex <= 0) {
    return Promise.resolve(false)
  }

  const prefix = iconName.slice(0, separatorIndex)
  const existingPromise = fullCollectionPromises.get(prefix)
  if (existingPromise) {
    return existingPromise
  }

  const collectionPromise = loadFullCollection(prefix)
  if (!collectionPromise) {
    return Promise.resolve(false)
  }
  const loadPromise = collectionPromise
    .then((collection) => {
      addCollection(collection)
      return true
    })
    .catch((error) => {
      fullCollectionPromises.delete(prefix)
      console.error(`图标集合加载失败: ${prefix}`, error)
      return false
    })
  fullCollectionPromises.set(prefix, loadPromise)
  return loadPromise
}
